import '../static/styles.module.css_.css';
const fieldbox = `_fieldbox_990f70b`;
const field = `_field_307b0e6`;
const floatingLabel = `_floatingLabel_de7ccf3`;
const hasSuffix = `_hasSuffix_0fa67be`;
const startSuffix = `_startSuffix_70f2f73`;
const centerSuffix = `_centerSuffix_57e22b3`;
const endSuffix = `_endSuffix_1923a0e`;
const cssModule0 = { fieldbox, field, floatingLabel, hasSuffix, startSuffix, centerSuffix, endSuffix };
export {
  cssModule0 as c
};
//# sourceMappingURL=styles.module.css_.module.D7vCQ6ZH.mjs.map
